/**
 * @desc 一键出库
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(opno: string | number, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/oneClickOutbound/${opno}`, {
      method: "POST",

      ...options,
    }),
  );
}
